theme.headerSticky = (function () {
  function ScrollSticky() {
    const wrapper = document.querySelector('#shopify__header__section');
    const target = wrapper?.querySelector('.header__sticky');
    if (!wrapper || !target || target.dataset.lumeruneStickyReady === 'true') return;
    target.dataset.lumeruneStickyReady = 'true';
    let headerHeight = 0;
    let headerTop = 0;
    let frame = null;
    let needsMeasure = true;
    let isSticky = target.classList.contains('sticky');
    let previousY = Math.max(0, window.scrollY);
    let travel = 0;
    let hidden = false;
    let keyboardNavigation = false;
    const canHover = window.matchMedia('(hover:hover)');

    const measure = () => {
      const wasSticky = target.classList.contains('sticky');
      if (wasSticky) target.classList.remove('sticky');
      const nextHeight = target.offsetHeight;
      headerTop = wrapper.getBoundingClientRect().top + Math.max(0, window.scrollY);
      if (nextHeight !== headerHeight) {
        headerHeight = nextHeight;
        wrapper.style.setProperty('--lr-header-space', `${headerHeight}px`);
      }
      if (wasSticky) target.classList.add('sticky');
    };

    const update = () => {
      frame = null;
      if (needsMeasure) {
        needsMeasure = false;
        measure();
      }
      const y = Math.max(0, window.scrollY);
      const delta = y - previousY;
      const nextSticky = y > headerTop;
      if (nextSticky !== isSticky) {
        target.classList.toggle('sticky', nextSticky);
        isSticky = nextSticky;
      }
      if (delta !== 0) {
        travel = Math.sign(delta) === Math.sign(travel) ? travel + delta : delta;
        keyboardNavigation = false;
      }
      const interacting = wrapper.contains(document.activeElement)
        || target.querySelector('details[open], [aria-expanded="true"]')
        || (canHover.matches && target.matches(':hover'));
      if (y <= headerTop + 16 || interacting || keyboardNavigation || window.Shopify?.designMode) {
        hidden = false;
        travel = 0;
      } else if (travel >= 24) {
        hidden = true;
      } else if (travel <= -12) {
        hidden = false;
      }
      target.classList.toggle('lr-header-hidden', hidden && nextSticky);
      previousY = y;
    };
    const scheduleMeasure = () => {
      needsMeasure = true;
      schedule();
    };
    const schedule = () => {
      if (frame === null) frame = window.requestAnimationFrame(update);
    };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', scheduleMeasure, { passive: true });
    window.addEventListener('pageshow', () => {
      previousY = Math.max(0, window.scrollY);
      scheduleMeasure();
    });
    window.addEventListener('keydown', (event) => {
      if (event.key === 'Tab') {
        keyboardNavigation = true;
        schedule();
      }
    });
    window.addEventListener('load', scheduleMeasure, { once: true });
    wrapper.addEventListener('focusin', schedule);
    wrapper.addEventListener('focusout', schedule);
    wrapper.addEventListener('pointerleave', schedule);
    wrapper.addEventListener('toggle', schedule, true);
    if (document.fonts?.ready) document.fonts.ready.then(scheduleMeasure);
    scheduleMeasure();
  }
  return ScrollSticky;
})();

